import axios from 'axios';
import { DEACTIVE_COURSE, ACTIVE_COURSE, ARCHIEVE_COURSE } from '../paths';

export const deactiveCourse = async (courseID) => {
  await axios.post(DEACTIVE_COURSE, { courseID });
};

export const activateCourse = async (courseID) => {
  await axios.post(ACTIVE_COURSE, { courseID });
};

export const archieveCourse = async (courseID) => {
  await axios.post(ARCHIEVE_COURSE, { courseID });
};
